var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoracao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 10C16.2417 8.78337 17.5 7.32504 17.5 5.41671C17.5 4.20113 17.0171 3.03534 16.1576 2.1758C15.298 1.31626 14.1322 0.833374 12.9167 0.833374C11.45 0.833374 10.4167 1.25004 9.16666 2.50004C7.91666 1.25004 6.88333 0.833374 5.41666 0.833374C4.20109 0.833374 3.0353 1.31626 2.17576 2.1758C1.31621 3.03534 0.833328 4.20113 0.833328 5.41671C0.833328 7.33337 2.08333 8.79171 3.33333 10L9.16666 15.8334L15 10Z",
    stroke: "#99A1AF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoracao);
export default __webpack_public_path__ + "static/media/coracao.42a2999b515e98b135cd8eec3e94a93a.svg";
export { ForwardRef as ReactComponent };